import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { RequestProvider } from '../../../context/RequestContext'
import { AirconRepair } from '../../../components/index/service-category/aircon-service/AirconRepair'
import { Services } from '../../../components/index/service/Services'
import { airconCostCalculation } from '../../../js/aircon-cost'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHvacServices, getWpNewHvacServices, setWpHvacServices, setWpNewHvacServices } from '../../../service/wp-blogs-store'
import { BottomButtons } from '@/index/service-category/aircon-service/BottomButtons'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    let lat = 1.3521
    let lng = 103.8198
    const { month, year } = getArticleDateTime();
    const modifiedDate = reviewedIso(CONTENT_REVIEWED);
    const airconBlogs = blogsMaster['hvac-services'].blogArray;
    const wpPosts = getWpHvacServices().length > 0 ?  getWpHvacServices() : await getWpPostsByCategory(6, "hvac-services");
    setWpHvacServices(wpPosts)
    const wpNewPosts = getWpNewHvacServices().length > 0 ?  getWpNewHvacServices() : await getWpNewPostsByCategory(6, "hvac-services");
    setWpNewHvacServices(wpNewPosts)

    const countryName = "Singapore"
    const allRequestCategorySettings = await getRequestJSON(countryName)
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")

    const currencyCd = "SGD"

    let standardServicing = []
    let annualServicing = []
    let chemicalServicing = []
    let overhaulServicing = []    

    airconCostCalculation(currencyCd, annualServicing, standardServicing, chemicalServicing, overhaulServicing)

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        standardServicing,
        countryName,
        currencyCd,
        wpNewPosts,
        wpPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const standardServicing = props.standardServicing
    const currencyCd = props.currencyCd
    const requestType = 'Aircon Services'
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const countryName = props.countryName

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ isQuickBook, setIsQuickBook ] = useState(false)

  return (
    <>
      <Head>
        <title>Aircon Fan Motor Replacement Guide & Repair Cost</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Aircon fan motor replacement can cost anywhere between $150 to $450 depending on the brand, model specifications and the technician charges."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Aircon Fan Motor Replacement Guide & Repair Cost`}/>
        <meta property="og:description" content="Aircon fan motor replacement can cost anywhere between $150 to $450 depending on the brand, model specifications and the technician charges." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-18T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/air-conditioner-blower.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/air-conditioner-blower.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor"/>
        <meta name="twitter:title" content={`Aircon Fan Motor Replacement Guide & Repair Cost`}/> 
        <meta name="twitter:description" content="Aircon fan motor replacement can cost anywhere between $150 to $450 depending on the brand, model specifications and the technician charges."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor"},"headline":"Faulty Aircon Fan Motor Replacement Guide & Repair Cost","description":"Aircon fan motor replacement can cost anywhere between $150 to $450 depending on the brand, model specifications and the technician charges.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/air-conditioner-blower.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-18T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore","name":"Aircon Servicing Singapore","url":"https://www.stringssg.com/sg/aircon-servicing-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor","name":"Aircon Fan Motor","url":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-fan-motor"}}]}]}`
          }}
        />
        </Head>
        <div>
            <RequestProvider>
                <section id="aircon-fan-motor-repair-replacement" className='relative'>
                    <AirconRepair 
                        setRequestForm={setRequestForm} 
                        setIsQuickBook={setIsQuickBook} 
                        title={"Aircon Fan Motor Replacement Guide & Repair Cost"} 
                        problem={"Replace Aircon Fan Motor for [brand name]"}
                        heroImage="blog/living/air-conditioner-blower.jpg"
                    />
                </section>
                {!requestForm &&
                    <BottomButtons countryName={countryName}/>
                }
                {requestForm && 
                    <Services
                        requestType={requestType}
                        requestCategorySettings={requestCategorySettings}
                        setRequestForm={setRequestForm}
                        isQuickBook={isQuickBook}
                        isCustomBook={false}
                        asSheet
                    />
                }
            </RequestProvider>
            <div className='max-w-5xl mx-auto py-10 px-2 leading-8'>
                <div className='py-2 space-y-5'>
                    <section className='space-y-2'>
                        <h2 className='font-bold text-xl md:text-2xl uppercase'>What is an aircon fan motor?</h2>
                        <p className=''>
                            An indoor aircon unit, commonly found in split-type air conditioning systems, contains a fan motor that plays a crucial role in the operation of the system. 
                            Here are some of the functions of the indoor aircon unit fan motor:
                        </p>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>1. Air Circulation</h3>
                            <p>
                                The indoor fan motor helps to  circulate the conditioned air within the room. When the air conditioning is switched on, the fan motor rotates the 
                                fan blades, which draw in air from the room and pass it over the evaporator coils. As the air get cold, it is then released back to the room to 
                                provide the cooling effect.
                            </p>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>2. Temperature Regulation</h3>
                            <p>
                            The fan motor helps maintain a consistent temperature throughout the room by ensuring that the cooled air is evenly distributed. This prevents hot 
                            spots and cold spots within the space.
                            </p>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>3. Air Filtration</h3>
                            <p>
                            Many indoor aircon units are equipped with air filters that help remove dust, allergens, and particles from the air. The fan motor assists in pulling air 
                            through these filters, enhancing indoor air quality.
                            </p>
                        </div>  
                        <div className='space-y-2'>
                            <h3 className='font-bold'>4. Humidity Control</h3>
                            <p>
                            In addition to cooling the air, the evaporator coils can also remove moisture, helping to control indoor humidity levels. The fan motor aids in the 
                            dehumidification process by blowing air over the coils.
                            </p>
                        </div>    
                        <div className='space-y-2'>
                            <h3 className='font-bold'>4. Quiet Operation</h3>
                            <p>
                            Modern indoor aircon units are designed for quiet operation. The fan motor is engineered to operate as quietly as possible to avoid causing disruptions 
                            in the living or working environment.
                            </p>
                        </div>
                    </section>
                    <section className='space-y-2'>
                        <h2 className='font-bold text-2xl'>How to replace indoor aircon unit fan motor (DIY)?</h2>
                        <p>
                            Replacing an indoor air conditioning fan motor is a complex task and typically requires technical knowledge and experience with air conditioning systems. 
                            Hiring a professional is highly recommended if you are not familiar with ac systems or electrical work. Improper handling of the process can cause further 
                            damage and safety risks. Here&apos;s a general outline of the steps involved in replacing an indoor aircon unit&apos;s fan motor:
                        </p>
                        <p className='font-bold'>
                            Note: This is a general guide and may not cover all specific models. Refer to your unit&apos;s manual and follow manufacturer guidelines.
                        </p>
                        <div>
                            <h3 className='font-bold'>Tools and Materials Needed:</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Replacement fan motor
                                </li>
                                <li>
                                Screwdrivers
                                </li>
                                <li>
                                Pliers
                                </li>
                                <li>
                                Wrenches
                                </li>
                                <li>
                                Multimeter
                                </li>
                                <li>
                                Electrical tape
                                </li>
                                <li>
                                Wire connectors
                                </li>
                            </ul>
                        </div>
                        <h3 className='font-bold'>Replacement Steps:</h3>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>1. Safety Precautions</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Ensure the power to the aircon unit is turned off. This involves both the electrical circuit breaker and the unit&apos;s power switch.
                                </li>
                                <li>
                                Verify that the unit is completely disconnected from electrical sources to prevent accidents.
                                </li>
                            </ul>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>2. Accessing the Fan Motor:</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Open the indoor unit&apos;s access panel. This may involve removing screws or clips that secure the panel.
                                </li>
                            </ul>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>3. Disconnecting Wires:</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Take a photo or make notes of the wiring connections to the fan motor. This will help during reinstallation.
                                </li>
                                <li>
                                Carefully disconnect the wires from the old fan motor using the appropriate tools.
                                </li>
                            </ul>
                        </div>     
                        <div className='space-y-2'>
                            <h3 className='font-bold'>4. Removing the Old Fan Motor</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Loosen and remove any mounting screws or brackets holding the fan motor in place.
                                </li>
                                <li>
                                Gently slide out the old fan motor from its housing.
                                </li>
                            </ul>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>5. Installing the New Fan Motor:</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Slide the new fan motor into the housing, aligning it properly.
                                </li>
                                <li>
                                Secure the motor in place using mounting screws or brackets.
                                </li>
                            </ul>
                        </div>   
                        <div className='space-y-2'>
                            <h3 className='font-bold'>6. Wiring the New Fan Motor</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Connect the wires to the new fan motor according to the notes or photos you took earlier.
                                </li>
                                <li>
                                Use wire connectors and electrical tape to ensure secure and proper connections.
                                </li>
                            </ul>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>7. Testing</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                Before fully closing the access panel, turn on the power to the aircon unit and test the new fan motor.
                                </li>
                                <li>
                                Listen for any unusual noises and ensure the fan blades are spinning smoothly.
                                </li>
                                <li>
                                Use a multimeter to verify that the electrical connections are working correctly.
                                </li>
                            </ul>
                        </div>
                        <div className='space-y-2'>
                            <h3 className='font-bold'>8. Finalizing</h3>
                            <ul className='list-disc px-4'>
                                <li>
                                If the fan motor is functioning properly, turn off the power again and securely close the access panel.
                                </li>
                                <li>
                                Double-check all connections, ensuring they are tight and secure.
                                </li>
                            </ul>
                        </div>
                    </section>                   
                    <div className='relative h-96'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/cool-air-from-aircon.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='aircon blowing cold air'
                        />          
                    </div>
                    <section className='py-2 space-y-2'>
                        <h2 className='text-xl font-bold uppercase'>Indications of a Faulty Indoor Unit Aircon Fan Motor</h2>
                        <div className='space-y-2'>
                            <p className=''>
                                A faulty aircon fan motor can lead to various symptoms and issues within your air conditioning system. If you notice any of the following indications, 
                                it could be a sign that your aircon fan motor is not functioning correctly and may require attention:
                            </p>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>1. Weak or No Airflow</h3>
                                <p>
                                    One of the most common signs of a faulty fan motor is a decrease in or complete lack of airflow from the indoor unit. You might feel little to no air 
                                    coming out of the vents.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>2. Uneven Cooling</h3>
                                <p>
                                If some areas of the room are significantly cooler than others or if there are hot spots, it could indicate that the fan motor is not circulating air 
                                properly, leading to uneven cooling.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>3. Loud or Unusual Noises</h3>
                                <p>
                                A malfunctioning fan motor may produce grinding, squealing, or rattling noises as it struggles to turn the fan blades. These noises can be indicative of 
                                worn bearings, loose components, or other mechanical issues.
                                </p>
                            </div>     
                            <div className='space-y-2'>
                                <h3 className='font-bold'>4. Fan Motor Not Running</h3>
                                <p>
                                In some cases, the fan motor might not start at all, leading to no airflow or cooling. This could be due to a motor failure, electrical issue, or 
                                a problem with the control board.
                                </p>
                            </div>
                            <div className='space-y-2'>
                                <h3 className='font-bold'>5. Unit Not Cooling Efficiently</h3>
                                <p>
                                If your aircon unit is running but is struggling to cool the room effectively, the fan motor might not be providing the necessary airflow over the 
                                evaporator coils for proper cooling.
                                </p>
                            </div>               
                        </div>
                    </section>
                    <section className='py-2 space-y-2'>
                        <h2 className='text-xl font-bold uppercase'>Aircon Indoor Unit Fan Motor Replacement Cost</h2>
                        <div className='space-y-5'>
                            <p>
                                The cost of replacing an aircon indoor unit fan motor can vary depending on several factors, including the brand and model of the air conditioning system
                                and the labor charges in your location. Additionally, the overall cost may also depend on whether other components, 
                                such as the blower or fan blades, need to be replaced along with the motor.
                            </p>
                            <p>
                                As an estimate, the cost of a replacement indoor unit fan motor can range from $150 to $450. This cost typically includes the price of the 
                                new fan motor, which can vary based on the specific system requirements and the brand. Additionally, you may need to factor in the cost of 
                                any associated parts, such as the blower or fan blades, if they are not included with the fan motor.
                            </p>
                        </div>
                    </section>             
                </div> 
            </div>
            <BlogsList blogs={airconBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/> 
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}